var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4109_19810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 39.9963C80 62.0841 62.0915 79.9926 40.0037 79.9926C17.9085 80 0 62.0841 0 39.9963C0 17.9085 17.9085 0 39.9963 0C62.0915 0 80 17.9085 80 39.9963Z",
    fill: "#F2994A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 39.9966C75 59.3264 59.3318 75 40 75C20.6682 75 5 59.3333 5 39.9966C5 20.6667 20.6682 5 40 5C59.3249 5 75 20.6667 75 39.9966Z",
    fill: "#F2994A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4109_19810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6471 22.1624V46.5772C44.6471 48.3187 43.0402 49.7451 41.0707 49.7396L39.5764 49.7451C37.6131 49.7396 36 48.3187 36 46.5772V22.1624C36 20.4209 37.6131 19 39.5764 19H41.0707C43.0339 19 44.6471 20.4264 44.6471 22.1624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3204 60.1566C42.7065 60.1566 44.6408 58.2561 44.6408 55.9118C44.6408 53.5674 42.7065 51.667 40.3204 51.667C37.9343 51.667 36 53.5674 36 55.9118C36 58.2561 37.9343 60.1566 40.3204 60.1566Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4109_19810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4109_19810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.64706,
    height: 41.3137,
    fill: "white",
    transform: "translate(36 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.5ec0e9ca77bc8ad9f86171df709e6d62.svg";
export { ForwardRef as ReactComponent };